<template>
    <div>
        <div class="leaderBox" v-if="showOrhide">
			<div class="newtext">新手指引</div>
			<img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
			<img src="../../../assets/images/ghpd1.png" class="steps step1" v-if="status==1">
			<img src="../../../assets/images/ghpd2.png" class="steps step2" v-if="status==2">
         <div class="stepbtn" @click="nextStep(status)">
				{{status==1?"下一步":status==2?"我知道了":"我知道了"}}
			</div>
            <div class="bottomTip">
				<el-checkbox v-model="checked">下次不再提示</el-checkbox>
			</div>
		</div>
        <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'交互跑动汇总表'}]"/>
        <div class="h-content">
            <div class="h-piece">
                <div class="">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
						<div class="h-formBox w-formBox">
							<div class="thir-formBox">
								<el-form-item label="区域"   v-if="showForm">
								    <brselect placeholder="请选择"
								              category="YLRegion"
								              :v="formInline.area"
								
								              clearable
								              v-model="formInline.area">
								    </brselect>
								</el-form-item>
								<el-form-item label="跑动时间">
								    <el-date-picker
								            :clearable="false"
								            type="date"
								            placeholder="选择时间"
								            v-model="formInline.careTime"
								            style="width: 100%;"
								            value-format="yyyy-MM-dd">
								    </el-date-picker>
								</el-form-item>
							</div>
							
							<el-form-item  class="right-btn">
								<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
								<el-button class="h-btn h-formBtn" @click="resetData"
								           style="background-color:white;color:black;border:1px solid #d1d1d1">重置
								</el-button>
							</el-form-item>
						</div>
                    </el-form>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn tablesblue ljjtableinputinner" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            :data="tableData"
                            stripe
							border
							max-height="600"
                            style="width: 100%">
                        </el-table-column>
                        <el-table-column
                                type="index"
                                width="40"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="area"
                                label="区域"
								:show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <dictname category="YLRegion"  :v="scope.row.area"/>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="cuname"
                                label="责任人"
								width="80"
								:show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="difference"
                                label="差在哪"
                                width="150"
								:show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.difference" v-if="a == 1 || (_user.usercode == scope.row.cucode && scope.row.userCarePaodDifference.status == 1)" placeholder="请输入"
                                          class="h-tableInput"></el-input>
                                <div v-else>{{scope.row.difference}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="programme"
                                label="关差方案"
                                width="150"
								:show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.programme" v-if="a == 1 || (_user.usercode == scope.row.cucode && scope.row.userCarePaodDifference.status == 1)" placeholder="请输入"
                                          class="h-tableInput"></el-input>
                                <div v-else>{{scope.row.programme}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="本周跑动">
                            <el-table-column
                                    prop="num1"
                                    :label="pd1"
									:show-overflow-tooltip="true"
                                    width="150">
                            </el-table-column>
                            <el-table-column
                                    prop="num2"
                                    :label="pd2"
									:show-overflow-tooltip="true"
                                    width="150">
                            </el-table-column>
                            <el-table-column
                                    prop="num3"
                                    :label="pd3"
									:show-overflow-tooltip="true"
                                    width="150">
                            </el-table-column>
                            <el-table-column
                                    prop="num4"
                                    :label="pd4"
									:show-overflow-tooltip="true"
                                    width="150">
                            </el-table-column>
                            <el-table-column
                                    prop="num5"
                                    :label="pd5"
									:show-overflow-tooltip="true"
                                    width="150">
                            </el-table-column>
                        </el-table-column>
                        <el-table-column
                                label="下周跑动">
                            <el-table-column
                                    prop="num6"
                                    :label="pd6"
									:show-overflow-tooltip="true"
                                    width="150">
                            </el-table-column>
                            <el-table-column
                                    prop="num7"
                                    :label="pd7"
									:show-overflow-tooltip="true"
                                    width="150">
                            </el-table-column>
                            <el-table-column
                                    prop="num8"
                                    :label="pd8"
									:show-overflow-tooltip="true"
                                    width="150">
                            </el-table-column>
                            <el-table-column
                                    prop="num9"
                                    :label="pd9"
									:show-overflow-tooltip="true"
                                    width="150">
                            </el-table-column>
                            <el-table-column
                                    prop="num10"
                                    :label="pd10"
									:show-overflow-tooltip="true"
                                    width="150">
                            </el-table-column>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="h-tableB h-mrt30">
                <div class="h-pagination2 h-pageCenter">
                    <pagination :page="formInline" @query="handleFilter"/>
                </div>
            </div>
        </div>
        <div class="h-txtCenter h-mrt60" style="margin: 1rem auto 0 auto;">
<!--            <el-button class="h-btn h-bBtn h-bgwhite" @click="renovate">返回</el-button>-->
            <!--<el-button class="h-btn h-bBtn h-bggreen" @click="saveTo">暂存</el-button>-->
            <el-button v-if="a == 1" class="h-btn h-bBtn h-bgblue2" @click="saveTo">保存</el-button>
            <el-button v-if="a == 2" class="h-btn h-bBtn h-bgblue2" @click="subTo">提交</el-button>
        </div>
    </div>
</template>
<script>

    import ss from '../../../api/SystemService';

    export default {
        data() {
            return {
                showOrhide:false,
                status:1,
                checked:true,
                toshow:"paodong",
                showForm: false,
                objectlists: [],
                pd1: '',
                pd2: '',
                pd3: '',
                pd4: '',
                pd5: '',
                pd6: '',
                pd7: '',
                pd8: '',
                pd9: '',
                pd10: '',
                a: '',
                formInline: {
                    area: '',
                    cunameLike: '',
                    careTime: '',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                tableData: [],
                q: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
            }
        },
        mounted() {
           
        },
        created() {
			// 遮罩
			this.showzhezhao()
            this.showF();
            this.showPD();
        },
        methods: {
			showzhezhao(){
				ss.salesList.toshow(this.toshow).then(rd => {
					console.log(rd)
				    if(rd == false){
				        this.showOrhide = false;
				    }else{
				        this.showOrhide = true;
				    }
				})
			},
            saveTo() {
                var entity = {
                    "ob1":this.tableData,
                    "ob2":this.pd1
                }
                ss.paodong.saveTo(entity).then(rd => {
                    this.$msg.msgs(rd.msg);
                    this.query();
                })
            },
            subTo() {
                var entity = {
                    "ob1":this.tableData,
                    "ob2":this.pd1
                }
                ss.paodong.subTo(entity).then(rd => {
                    this.$msg.msgs(rd.msg);
                    this.query();
                })
            },
            showPD() {
                ss.paodong.showPD().then(rd => {
                    this.objectlists = [];
                    rd.forEach((item, index) => {
                        this['pd' + (index + 1)] = item;
                        this.objectlists.push(item);
                    })
                    this.query();
                })
            },
            query() {
                ss.paodong.page(this.q).then(rd => {
                    // this.tableData = rd.records;
                    this.formInline.total = rd.total;
                    if (this.$store.getters.hasRole('swyl_guanhgly,swyl_admin')) {
                        this.a = 1;
                    }
                    if (this.$store.getters.hasRole('swyl_quyujl,swyl_xiaoshoujl')) {
                        this.a = 2;
                    }
                    this.tableData = [];
                    if (rd.records) {
                        for (var i = 0; i < rd.records.length; i++) {
                            this.setItemDate(rd.records[i])
                            if(rd.records[i].userCarePaodDifference){
                            }else{
                                rd.records[i].userCarePaodDifference = {
                                    status: 1
                                };
                            }
                        }
                        this.tableData = rd.records;
                    }
                })
            },
            selectPD(v) {
                if (v == '') {
                    this.selectPage();
                }else{
                    ss.paodong.selectPD(v).then(rd => {
                        this.objectlists = [];
                        rd.forEach((item, index) => {
                            this['pd' + (index + 1)] = item;
                            this.objectlists.push(item);
                        })
                    })
                    this.selectPage();
                }

            },
            selectPage() {
                ss.paodong.selectPage(this.formInline).then(rd => {
                    // this.tableData = rd.records;
                    this.formInline.total = rd.total;
                    if (rd.records) {
                        for (var i = 0; i < rd.records.length; i++) {
                            this.setItemDate(rd.records[i])
                            if(rd.records[i].userCarePaodDifference){
                            }else{
                                rd.records[i].userCarePaodDifference = {
                                    status: 1
                                };
                            }
                        }
                        this.tableData = rd.records;
                    }
                })
            },
            setItemDate(obj) {
                for (var j = 0; j < this.objectlists.length; j++) {
                    var ol = this.objectlists[j];
                    obj['num' + (j + 1)] = obj.map[ol] || null;
                }
            },
            handleFilter() {
                this.selectPD(this.formInline.careTime);
            },
            resetData() {
                this.formInline.area = '';
                this.formInline.careTime = '';
                this.formInline.pageSize = 10;
                this.showPD();
            },
            showF(){
                if (this.$store.getters.hasRole('swyl_guanhgly,swyl_admin')) {
                    this.showForm = true;
                }
            },
            renovate() {
                this.handleFilter();
            },
            // 关闭新手引导页
			closeIt(){
				this.showOrhide = false;
				if(this.checked){
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}
            },
            nextStep(i){
				if(this.status ==1){
						this.status = 2;
				}else if(this.status ==2){
					if(this.checked){
                        ss.salesList.toshow(this.toshow,this.checked).then(rd => {
                        	console.log(rd)
                        	this.showOrhide = false;
                        })
					}else{
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					}
				}
			}
        }
    }
</script>
<style>
    .tablesblue .el-table thead.is-group th {
        background: none;
    }

    .tablesblue .el-table th.is-leaf {
        border-right: none;
    }

    .tablesblue .el-table--border th, .el-table__fixed-right-patch {
        border-bottom: none;
        border-right: none;
    }
	
	.ljjtableinputinner .h-tableInput .el-input__inner{
		padding: 0.02rem 0.1rem;
	}
</style>
<style scoped lang="scss">
    .bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
	}
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}
    .leaderBox{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;
		.leaderbg{
			width: 100%;
			height: 100%;
		}
		.steps{
			position: absolute;
			z-index: 1;
		}
		.step1{
			top: 0.8rem;
			left: 0rem;
			width: 5.1rem;
			height: 8rem;
		}
		.step2{
			top: 1.65rem;
			left: 3rem;
			width: 7.7rem;
			height: 1.8rem;
		}
		.stepbtn{
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0,0,0,0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.65rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}
		.closeIt{
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
		}
	}
</style>
